import { render } from "./MyDashboard.vue?vue&type=template&id=dbdbaa2e"
import script from "./MyDashboard.vue?vue&type=script&lang=js"
export * from "./MyDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__